import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {AbstractionComponent} from "@biletix/core/common/abstraction-component";
import {RouterService} from "@biletix/core/services/router.service";
import {ShoppingCartState} from "@biletix/core/models/state/shopping-cart-state.model";
import {ShoppingCart} from "@biletix/core/models/shopping-cart/shopping-cart.model";
import {PerformancePageStateService} from "@biletix/features/performance/services/performance-page-state.service";
import {TicketSaleService} from "@biletix/core/services/ticket-sale.service";
import {Observable, of} from "rxjs";
import {map} from "rxjs/operators";
import { Router } from '@angular/router';
import { CartTimeoutService } from '@biletix/core/services/cart-timeout.service';
import { CityService } from '@biletix/core/services/city.service';
import { City } from '@biletix/core/models/city.model';
import { environment } from '@biletix/env';
import { MatDialog } from '@angular/material/dialog';
import { BtxDateRangePickerDialogComponent } from '../../../components/date-range-picker-dialog/date-range-picker-dialog.component';

@Component({
  standalone: false,
  selector: 'btx-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent extends AbstractionComponent implements OnInit {

  private readonly searchBaseUrl = environment.search.baseUrl;

  @Output() public sidenavToggle = new EventEmitter();
  ticketCount$: Observable<number> = of(0);
  shoppingCartState?: ShoppingCartState;
  cities: City[] = [];
  selectedCity: string = '-1';
  selectedDate: string = '-1';
  selectedCategory: string = '-1';

  customStartDate: Date | null = null;
  customEndDate: Date | null = null;
  previousDateSelection: string = '-1';
  //cartStateValue: boolean = false;

  constructor(
    private routerService: RouterService,
    private performancePageStateService: PerformancePageStateService,
    private cartTimeoutService: CartTimeoutService,
    private ticketSaleService: TicketSaleService,
    private router: Router,
    private cityService: CityService,
    private dialog: MatDialog) {
    super();

    // router.events.subscribe((val) => {
    //   // see also
    //   this.changeCartState();
    // });
  }



  ngOnInit(): void {
    // this.performancePageStateService
    //         .shoppingCartStateChange
    //         .pipe(this.takeUntilDestroy())
    //         .subscribe(cart => {
    //           console.log("Header cart state changed");
    //           this.shoppingCartState = cart
    //         });

    this.cartTimeoutService
    .shoppingCartStateChange
    .pipe(this.takeUntilDestroy())
    .subscribe(shoppingCartState =>{
        this.shoppingCartState =shoppingCartState;
    });

    this.ticketCount$ = this.ticketSaleService
            .watchShoppingCart.pipe(this.takeUntilDestroy())
            .pipe(map((cart: ShoppingCart) => cart?.totalTicket ?? 0));

    this.cityService.getActiveCities()
      .pipe(this.takeUntilDestroy())
      .subscribe(cities => {
        this.cities = cities;
      });
  }

  discover() {
    const regionAndLanguagePath = this.routerService.regionLanguagePath;
    const queryParams: string[] = [];

    if (this.selectedCategory !== '-1') {
      queryParams.push(`maincategory=${encodeURIComponent(this.selectedCategory)}`);
    }
    if (this.selectedCity !== '-1') {
      queryParams.push(`city=${encodeURIComponent(this.selectedCity)}`);
    }
    if (this.selectedDate !== '-1') {
      if (this.selectedDate === 'daterange' && this.customStartDate && this.customEndDate) {
        queryParams.push(`gt=${this.formatIsoDate(this.customStartDate)}`);
        queryParams.push(`lt=${this.formatIsoDate(this.customEndDate)}`);
      } else {
        queryParams.push(`date=${encodeURIComponent(this.selectedDate)}`);
      }
    }

    let url = this.searchBaseUrl + regionAndLanguagePath;
    if (queryParams.length > 0) {
      url += '?' + queryParams.join('&');
    }

    window.location.href = url;
  }

  get hasIframe(): boolean {
    const adDiv = document.getElementById('div-gpt-ad-1594640818191-0');
    if (!adDiv) return false;
    return adDiv.querySelector('iframe') !== null;
  }

  getDateLabel(value: string): string {
    switch (value) {
      case '-1': return 'home.labels.allDates';
      case 'today': return 'home.labels.today';
      case 'weekend': return 'home.labels.weekend';
      case 'nextweekend': return 'home.labels.nextWeekend';
      case 'thisweek': return 'home.labels.thisWeek';
      case 'next14days': return 'home.labels.next14Days';
      case 'next30days': return 'home.labels.next30Days';
      case 'daterange': return 'home.labels.dateRange';
      default: return '';
    }
  }

  onDateChange(event: any): void {
    if (event.value === 'daterange') {
      const dialogRef = this.dialog.open(BtxDateRangePickerDialogComponent, {
        width: '95vw',
        maxWidth: '780px',
        panelClass: 'custom-datepicker-dialog-panel',
        data: {
          startDate: this.customStartDate,
          endDate: this.customEndDate
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result && result.startDate && result.endDate) {
          this.customStartDate = result.startDate;
          this.customEndDate = result.endDate;
          this.selectedDate = 'daterange';
          this.previousDateSelection = 'daterange';
        } else {
          // If cancelled, revert to the previous selection
          this.selectedDate = this.previousDateSelection;
        }
      });
    } else {
      this.previousDateSelection = event.value;
      this.customStartDate = null;
      this.customEndDate = null;
    }
  }

  isCustomRange(): boolean {
    return this.selectedDate === 'daterange' && this.customStartDate !== null && this.customEndDate !== null;
  }

  isHomepage(): boolean {
    const urlPath = this.router.url.split('?')[0].split('#')[0];
    return urlPath === '/' || urlPath === '/anasayfa' || urlPath.startsWith('/anasayfa/');
  }

  getFormattedRange(): string {
    if (this.customStartDate && this.customEndDate) {
      const startDay = String(this.customStartDate.getDate()).padStart(2, '0');
      const startMonth = String(this.customStartDate.getMonth() + 1).padStart(2, '0');
      const startYear = this.customStartDate.getFullYear();

      const endDay = String(this.customEndDate.getDate()).padStart(2, '0');
      const endMonth = String(this.customEndDate.getMonth() + 1).padStart(2, '0');
      const endYear = this.customEndDate.getFullYear();

      if (startYear === endYear) {
        return `${startDay}.${startMonth} - ${endDay}.${endMonth}.${endYear}`;
      }
      return `${startDay}.${startMonth}.${startYear} - ${endDay}.${endMonth}.${endYear}`;
    }
    return '';
  }

  formatDate(date: Date): string {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
  }

  formatUrlDate(date: Date): string {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  formatIsoDate(date: Date): string {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  }

  getCategoryLabel(value: string): string {
    switch (value) {
      case '-1': return 'home.labels.allCategories';
      case 'MUSIC': return 'home.labels.categoryMusic';
      case 'SPORT': return 'home.labels.categorySport';
      case 'ART': return 'home.labels.categoryArt';
      case 'FAMILY': return 'home.labels.categoryFamily';
      case 'OTHER': return 'home.labels.categoryOther';
      default: return '';
    }
  }

  // changeCartState(){
  //   if (this.router.url.indexOf('/cart') > -1) {
  //     this.cartStateValue = true;
  //   }else{
  //     this.cartStateValue = false;
  //   }
  // }

  showTimerInHeader(){
    //const isMobile = this.getIsMobile();
    const isExistShoppingCart =this.isExistShoppingCart();
    const isCartPage =this.isCartPage();
    const isOrderSummaryExists =this.isOrderSummaryExists();

    //return !isMobile && isExistShoppingCart && !isCartPage&&!isOrderSummaryExists;
    return isExistShoppingCart && !isCartPage&&!isOrderSummaryExists;

  }

  isOrderSummaryExists(){
    return this.shoppingCartState && this.shoppingCartState.isNotEmpty();
  }

  isCartPage() {
    return this.router.url.indexOf('/cart') > -1;
  }


  isExistShoppingCart(): boolean {
      return this.ticketSaleService.isExistShoppingCart();
  }

  public onToggleSidenav = () => {
    this.sidenavToggle.emit();
  }

  ngAfterViewInit(): void{

  }

}
